import React from 'react'
import t from 'prop-types'
import { css } from 'linaria'
import cx from 'classnames'
import SectionHeader from '../SectionHeader'
import Image from '../../Images/Image'

const headingCSS = css`
  * a {
    @apply text-blue-200 transition-colors transition-opacity ease-linear duration-500;
    &:hover {
      @apply text-blue-100 opacity-75;
    }
  }
`

const Hero = ({
  heading,
  isOnDarkBg,
  size100,
  size200,
  size300,
  logo,
  sectionHeader,
}) => {
  return (
    <div className="container">
      <div className="lg:max-w-screen-lg lg:pr-10">
        {sectionHeader && (
          <div className="mb-16">
            <SectionHeader {...sectionHeader}></SectionHeader>
          </div>
        )}
        {logo && <Image className="block w-auto h-24" src={logo.src} />}
        <div
          className={cx(`${headingCSS} font-serif leading-tight`, {
            'mt-10': logo,
            'text-white': isOnDarkBg,
            'font-bold text-2xl lg:text-3xl': size100,
            'font-bold text-3xl lg:text-4xl': size200,
            'font-semibold text-4xl lg:text-5xl': size300,
          })}
          dangerouslySetInnerHTML={{ __html: heading }}
        />
      </div>
    </div>
  )
}

Hero.propTypes = {
  heading: t.string,
  isOnDarkBg: t.bool,
  isLarge: t.bool,
  logo: t.string,
  sectionHeader: t.object,
  size100: t.bool,
  size200: t.bool,
  size300: t.bool,
}

Hero.defaultProps = {}

export default Hero
